import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { googleAnalyticsConfig } from "config";
import useAuth from "../hooks/useAuth";
import * as apis from "../apis";
import { getYMDHMSFormatDTString } from "utils/dateUtil";

/**
 * uri 변경 추적 컴포넌트
 * uri가 변경될 때마다 pageview 이벤트 전송
 */
const RouteChangeTracker = () => {
  const location = useLocation();
  const { user } = useAuth();
  const [initialized, setInitialized] = useState(false);

  // localhost는 기록하지 않음
  useEffect(() => {
    if (
      !window.location.href.includes("localhost") &&
      googleAnalyticsConfig != null &&
      googleAnalyticsConfig != "null"
    ) {
      ReactGA.initialize(googleAnalyticsConfig);
      setInitialized(true);
    }
  }, []);

  // location 변경 감지시 pageview 이벤트 전송
  useEffect(() => {
    console.log("initialized : ", initialized);

    if (initialized && user != null && user.username != null) {
      ReactGA.set({ userId: user.username });
    }
  }, [user]);

  useEffect(() => {
    if (initialized) {
      ReactGA.set({ page: location.pathname });
      let auth_id = "getCurrentIp error";
      let ip_addr = "getCurrentIp error";
      const page_local_time = getYMDHMSFormatDTString(new Date());
      if (user != null && user.username != null) {
        apis.user
          .getCurrentIp()
          .then((res: any) => {
            auth_id = res.authId + "(" + res.clientIp + ")";
            ip_addr = res.clientIp;
          })
          .catch((e) => {})
          .finally(() => {
            ReactGA.send({
              hitType: "pageview",
              page: location.pathname,
              title: location.pathname,
              auth_id,
              ip_addr,
              page_local_time,
            });
          });
        apis.user
          .insertUserLog({
            log_type: "page_view",
            page_name: location.pathname,
          })
          .catch((e) => {});
      }
    }
  }, [initialized, location]);

  return <div></div>;
};

export default RouteChangeTracker;
